import React, { useEffect, useState } from "react";
import {
  Box,
  CircularProgress,
  Grid,
  Typography,
  TableBody,
  TableCell,
  TableRow,
  TableContainer,
  TableHead,
  Table,
  Button,
  FormControl,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  Skeleton,
  InputAdornment,
  Tooltip,
  IconButton,
} from "@mui/material";
import { tableCellLab, tableRowLab } from "../../style/LapPageStyle";
import "react-toastify/dist/ReactToastify.css";
import CustomModal from "../CustomModal/CustomModal";
// import PastBillsPharmacy from "./PastBillsPharmacy";
import UseFetchCollections from "../../helper/UseFetchCollections";
import PastBillPharmacyByInvoice from "../ModalChildren/PastBillPharmacyByInvoice";
import Loader from "../UI/Loader";
import not_found from "../../assets/not_found.svg";
import { primaryBtnTeal } from "../../style/PatientDetailsStyle";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import dayjs, { Dayjs } from "dayjs";
import useDebounce from "../../hooks/UseDebounce";
import SearchIcon from "@mui/icons-material/Search";
import { ClearIcon } from "@mui/x-date-pickers";
import RefreshIcon from "@mui/icons-material/Refresh";
import ReactSelect from "react-select";
import { getTotalCollection } from "../../connections/getApi";
import { linkInvoiceToPatient } from "../../connections/putApi";
import { showToast } from "../../utils/toastUtil";
import UseSearchPatient from "../../helper/UseSearchPatient";

const PharmacyTodaysCollection = () => {
  const [selectedDate, setSelectedDate] = useState(null);
  const [startDate, setStartDate] = useState(
    dayjs().tz("Asia/Kolkata").format("YYYY-MM-DD"),
  );
  const [endDate, setEndDate] = useState(
    dayjs().tz("Asia/Kolkata").format("YYYY-MM-DD"),
  );

  const handleStartDateChange = (event) => {
    if (!startDate) {
      setPage(1);
    }
    setStartDate(event.target.value);
  };

  const handleEndDateChange = (event) => {
    if (!endDate) {
      setPage(1);
    }
    setEndDate(event.target.value);
  };

  const [page, setPage] = useState(1);
  const [itemPerPage, setItemPerPage] = useState(20);
  const [openBillByInvoice, setOpenBillByInvoice] = useState(false);
  // const [total, setTotal] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [selectedInvoiceId, setSelectedInvoiceId] = useState(null);
  const [selectedInvoiceUid, setSelectedInvoiceUid] = useState(null);

  const debounceValue = useDebounce(searchValue, 500);

  const [linkingInvoiceId, setLinkingInvoiceId] = useState(null);
  const [patientSearchQuery, setPatientSearchQuery] = useState("");
  const [patientOptions, setPatientOptions] = useState([]);
  const [selectedLinkPatient, setSelectedLinkPatient] = useState(null);
  const [linkLoading, setLinkLoading] = useState(false);

  const debouncedPatientSearch = useDebounce(patientSearchQuery, 500);
 const { data: searchResult, isFetching } = UseSearchPatient({q:debouncedPatientSearch,page:1, perPage:10});

  const {
    data: collectionArray,
    refetch,
    isLoading,
  } = UseFetchCollections(
    startDate,
    "generated",
    endDate,
    page,
    itemPerPage,
    debounceValue
  );

  useEffect(() => {
    if (startDate && endDate) {
      refetch();
    }
    // setTotal(collectionArray?.meta?.total_collection || 0)
  }, [startDate, endDate, itemPerPage, page]);

  useEffect(() => {
    if (!debouncedPatientSearch?.trim()) {
      setPatientOptions([]);
      return;
    }

    const patientsData = searchResult?.payload?.patients || [];
    setPatientOptions(
      patientsData.map((inv) => ({
        value: inv?.id,
        label: `${inv?.full_name} (${inv?.uid})${inv?.mobile ? ` - ${inv?.mobile}` : ""}`,
      })),
    );
  }, [debouncedPatientSearch, searchResult]);
  const handleOpenLinkPatient = (invoiceId) => {
    setLinkingInvoiceId(invoiceId);
    setSelectedLinkPatient(null);
    setPatientSearchQuery("");
    setPatientOptions([]);
  };

  const handleCancelLink = () => {
    setLinkingInvoiceId(null);
    setSelectedLinkPatient(null);
    setPatientSearchQuery("");
    setPatientOptions([]);
  };

  const handleLinkPatient = async (invoiceId) => {
    if (!selectedLinkPatient) return;
    setLinkLoading(true);
    try {
      const res = await linkInvoiceToPatient(invoiceId, selectedLinkPatient.value);
      if (res?.status?.status === "SUCCESS") {
        showToast(res?.status?.message || "Patient linked successfully", "SUCCESS");
        handleCancelLink();
        refetch();
      } else {
        showToast(res?.status?.message || "Failed to link patient", "ERROR");
      }
    } catch {
      showToast("Failed to link patient", "ERROR");
    } finally {
      setLinkLoading(false);
    }
  };

  const handleOpenBillByInvoice = (id) => {
    setSelectedInvoiceId(id);
    setOpenBillByInvoice(true);
  };

  const handlePrevious = () => {
    if (page > 1) setPage((prev) => prev - 1);
  };

  const totalRecords = collectionArray?.meta?.total_count || 0;
  const totalPage = Math.ceil(totalRecords / itemPerPage);

  const handleNext = () => {
    if (page < totalPage) setPage((prev) => prev + 1);
  };

  const handleOpenBillByInvoiceClose = () => setOpenBillByInvoice(false);

  // Add this function
  const handleClearDates = () => {
    setStartDate("");
    setEndDate("");
    setPage(1);
    refetch(); // optional: immediately fetch data without date filter
  };

  const getPaymentModeLabel = (invoice) => {
    const modes = (invoice?.invoice_payments || [])
      .map((p) => p?.payment_mode)
      .filter(Boolean);

    // remove duplicates
    const unique = [...new Set(modes)];

    return unique.length ? unique.join(" + ") : "-";
  };

  return (
    <Box
      sx={{
        width: "100%",
        minHeight: "65vh",
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
      }}
    >
      <Box>
        <Box
          display="flex"
          justifyContent="space-between"
          width="100%"
          sx={{ flexWrap: "wrap", gap: 2 }}
        >
          <Box sx={{ gap: 2, display: "flex", flexWrap: "wrap" }}>
            {/* Start Date */}
            <FormControl variant="outlined" sx={{ width: "160px" }}>
              <TextField
                type="date"
                label="Start Date"
                value={startDate}
                onChange={handleStartDateChange}
                inputProps={{ max: endDate }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "40px",
                    borderRadius: "15px",
                    fontSize: "14px",
                    backgroundColor: "#F7F7FF",
                    fontWeight: "600",
                  },
                  "& fieldset": { border: "none" },
                  cursor: "pointer",
                }}
                InputLabelProps={{
                  shrink: true,
                }}
              />
            </FormControl>

            {/* End Date */}
            <FormControl variant="outlined" sx={{ width: "160px" }}>
              <TextField
                type="date"
                label="End Date"
                value={endDate}
                onChange={handleEndDateChange}
                inputProps={{
                  min: startDate,
                  max: new Date().toISOString().split("T")[0],
                }}
                InputLabelProps={{
                  shrink: true,
                }}
                sx={{
                  "& .MuiOutlinedInput-root": {
                    height: "40px",
                    borderRadius: "15px",
                    fontSize: "14px",
                    backgroundColor: "#F7F7FF",
                    fontWeight: "600",
                  },
                  "& fieldset": { border: "none" },
                  cursor: "pointer",
                }}
              />
            </FormControl>

            {/* Clear Dates Button */}

            {/* Clear Dates Button with Tooltip */}
            <Tooltip title="Clear Dates">
              <RefreshIcon
                sx={{
                  color: "#e11616ff",
                  fontSize: 20,
                  height: 33,
                  width: 34,
                  borderRadius: "16px",
                  marginLeft: "-10px",
                  "&:hover": { color: "#b44e4eff" },
                  cursor: "pointer",
                  marginTop: "2px",
                }}
                onClick={handleClearDates}
              />
              {/* </IconButton> */}
            </Tooltip>

            <FormControl
              variant="outlined"
              sx={{ width: "160px", marginLeft: "10px" }}
            >
              <TextField
                // label="Search by Name and Invoice id"
                placeholder="Search by Name / Invoice ID"
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon sx={{ color: "gray", fontSize: 20 }} />
                    </InputAdornment>
                  ),
                }}
                sx={{
                  minWidth: 250,
                  "& .MuiOutlinedInput-root": {
                    height: "40px",
                    borderRadius: "15px",
                    fontSize: "14px",
                    backgroundColor: "#F7F7FF",
                    fontWeight: "400",
                  },
                  "& fieldset": { border: "none" },
                  cursor: "pointer",
                }}
              />
            </FormControl>
          </Box>

          <Box
            display="flex"
            justifyContent="space-between"
            alignItems="center"
            sx={{ gap: 2 }}
          >
            <Typography fontWeight={"bold"} variant="h6" mb={2}></Typography>

            <Typography
              fontWeight={"600"}
              mb={2}
              sx={{
                backgroundColor: "#F7F7FF",
                padding: "10px",
                borderRadius: "12px",
              }}
            >
              <Typography fontSize={"16px"} variant="span">
                {" "}
                Collection{" "}
              </Typography>{" "}
              &#8377;{" "}
              {collectionArray?.meta?.total_collection
                ? collectionArray.meta.total_collection.toFixed(2)
                : "0.00"}
            </Typography>
          </Box>
        </Box>

        <Grid container sm={12} md={12} marginBottom={"auto"} lg={12}>
          <Grid item xs={12}>
            <TableContainer
              sx={{
                mt: 2,
                width: "100%",
                overflowY: "scroll",
                "&::-webkit-scrollbar": {
                  display: "none",
                },
                "-ms-overflow-style": "none",
                "scrollbar-width": "none",
              }}
            >
              <Table
                sx={{
                  width: "100%",
                  overflowY: "scroll",
                  "&::-webkit-scrollbar": {
                    display: "none", // Hide the scrollbar for Webkit browsers (Chrome, Safari)
                  },
                  "-ms-overflow-style": "none", // Hide scrollbar for IE and Edge
                  "scrollbar-width": "none",
                }}
              >
                <TableHead stickyHeader>
                  <TableRow sx={{ textAlign: "center" }}>
                    <TableCell
                      sx={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        p: "6px",
                        textAlign: "center",
                      }}
                    >
                      Sr No.
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        p: "6px",
                        textAlign: "center",
                      }}
                    >
                      Name
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        p: "6px",
                        textAlign: "center",
                        width: "200px",
                      }}
                    >
                      Patient ID
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        p: "6px",
                        textAlign: "center",
                      }}
                    >
                      Invoice Id
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        p: "6px",
                        textAlign: "center",
                      }}
                    >
                      Amount
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        p: "6px",
                        textAlign: "center",
                      }}
                    >
                      Payment Mode
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        p: "6px",
                        textAlign: "center",
                      }}
                    >
                      Generated at
                    </TableCell>
                    <TableCell
                      sx={{
                        fontSize: "14px",
                        fontWeight: "bold",
                        p: "6px",
                        textAlign: "center",
                      }}
                    ></TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {isLoading
                    ? // Show 5 skeleton rows while loading
                      Array.from(new Array(5)).map((_, index) => (
                        <TableRow key={index}>
                          {[...Array(9)].map((_, i) => (
                            <TableCell key={i}>
                              <Skeleton variant="rectangular" height={18} />
                            </TableCell>
                          ))}
                        </TableRow>
                      ))
                    : collectionArray?.payload?.invoices?.map(
                        (invoice, index) => {
                          const generatedAt = dayjs(
                            invoice?.generated_at,
                            "YYYY-MM-DD hh:mm A",
                          );
                          const hoursDiff = dayjs().diff(generatedAt, "hour"); // get difference in hours
                          const isOlderThan36Hours = hoursDiff > 36;

                          return (
                            <TableRow
                              key={index}
                              sx={{
                                ...tableRowLab,
                                borderBottom: "8px solid white",
                                borderTop:
                                  index === 0 ? "4px solid white" : " ",
                                // "&:hover": {
                                //   transform: "scale(1.001)",
                                //   boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                                //   borderRadius: "20px !important",
                                // },
                              }}
                            >
                              <TableCell
                                sx={{
                                  ...tableCellLab,
                                  paddingY: "8px",
                                  borderTopLeftRadius: "20px",
                                  borderBottomLeftRadius: "20px",
                                }}
                              >
                                <Typography
                                  variant="body_Grey1"
                                  color={
                                    invoice?.grand_total < 0
                                      ? "neutral.textDanger"
                                      : "text.black"
                                  }
                                >
                                  {index + 1}
                                </Typography>
                              </TableCell>

                              <TableCell sx={tableCellLab}>
                                <Typography
                                  color={
                                    invoice?.grand_total < 0
                                      ? "neutral.textDanger"
                                      : "text.black"
                                  }
                                  variant="heading2"
                                >
                                  {" "}
                                  {invoice.name}
                                </Typography>
                                {/* <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                <MobileScreenShareRoundedIcon sx={{ height: "12px", width: "12px" }} />
                <Typography variant="body2_text">
                  {" "}
                  {"1234567890"}
                </Typography>
              </Box> */}
                              </TableCell>

                              <TableCell sx={{ ...tableCellLab, width: "200px", maxWidth: "200px" }}>
                                {invoice?.patient_uid ? (
                                  <Typography
                                    color={
                                      invoice?.grand_total < 0
                                        ? "neutral.textDanger"
                                        : "text.black"
                                    }
                                    variant="body_Grey1"
                                  >
                                    {invoice.patient_uid}
                                  </Typography>
                                ) : linkingInvoiceId === invoice.id ? (
                                  <Box display="flex" alignItems="center" gap="4px" sx={{ flexWrap: "nowrap", width: "100%" }}>
                                   <Tooltip title={selectedLinkPatient?.label}>
                                    <Box sx={{ flex: 1, minWidth: 0 }}>
                                      <ReactSelect
                                        menuPortalTarget={document.body}
                                        isLoading={isFetching}
                                        filterOption={() => true}
                                        styles={{
                                          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                                          control: (base) => ({
                                            ...base,
                                            minHeight: 28,
                                            height: 28,
                                            fontSize: 11,
                                            borderRadius: 8,
                                            borderColor: "#0097B2",
                                            boxShadow: "none",
                                            "&:hover": { borderColor: "#0097B2" },
                                          }),
                                          valueContainer: (base) => ({ ...base, padding: "0 6px" }),
                                          input: (base) => ({ ...base, margin: 0, padding: 0, fontSize: 11 }),
                                          indicatorsContainer: (base) => ({ ...base, height: 28 }),
                                          indicatorSeparator: () => ({ display: "none" }),
                                          dropdownIndicator: (base) => ({ ...base, padding: "0 4px" }),
                                          clearIndicator: (base) => ({ ...base, padding: "0 2px" }),
                                          option: (base, state) => ({
                                            ...base,
                                            fontSize: 11,
                                            padding: "5px 8px",
                                            backgroundColor: state.isFocused ? "#e6f7fa" : "white",
                                            color: "#333",
                                          }),
                                          singleValue: (base) => ({ ...base, fontSize: 11 }),
                                          placeholder: (base) => ({ ...base, fontSize: 11, color: "#aaa" }),
                                        }}
                                        placeholder="Search Patient..."
                                        options={patientOptions}
                                        value={selectedLinkPatient}
                                        inputValue={patientSearchQuery}
                                        onInputChange={(val, { action }) => {
                                          if (action !== "input-blur" && action !== "menu-close") {
                                            setPatientSearchQuery(val);
                                          }
                                        }}
                                        onChange={(opt) => setSelectedLinkPatient(opt)}
                                        isClearable
                                      />
                                    </Box>
                                    </Tooltip>
                                    <Tooltip title="Confirm">
                                      <span>
                                        <IconButton
                                          size="small"
                                          disabled={!selectedLinkPatient || linkLoading}
                                          onClick={() => handleLinkPatient(invoice.id)}
                                          sx={{
                                            width: 24,
                                            height: 24,
                                            color: selectedLinkPatient && !linkLoading ? "#0097B2" : "#ccc",
                                            "&:hover": { color: "#007A99" },
                                          }}
                                        >
                                          {linkLoading ? (
                                            <CircularProgress size={12} sx={{ color: "#0097B2" }} />
                                          ) : (
                                            <CheckIcon sx={{ fontSize: 14 }} />
                                          )}
                                        </IconButton>
                                      </span>
                                    </Tooltip>
                                    <Tooltip title="Cancel">
                                      <IconButton
                                        size="small"
                                        onClick={handleCancelLink}
                                        sx={{
                                          width: 24,
                                          height: 24,
                                          color: "#999",
                                          "&:hover": { color: "#555" },
                                        }}
                                      >
                                        <CloseIcon sx={{ fontSize: 14 }} />
                                      </IconButton>
                                    </Tooltip>
                                  </Box>
                                ) : (
                                  <Typography
                                    onClick={() => handleOpenLinkPatient(invoice.id)}
                                    sx={{
                                      color: "#0097B2",
                                      cursor: "pointer",
                                      fontSize: "12px",
                                      fontWeight: 500,
                                      textDecoration: "underline",
                                      textUnderlineOffset: "2px",
                                      "&:hover": { color: "#007A99" },
                                    }}
                                  >
                                    Link Invoice
                                  </Typography>
                                )}
                              </TableCell>

                              <TableCell sx={tableCellLab}>
                                <Typography
                                  color={
                                    invoice?.grand_total < 0
                                      ? "neutral.textDanger"
                                      : "text.black"
                                  }
                                  variant="body_Grey1"
                                >
                                  {invoice?.uid}
                                  {invoice?.old_uid
                                    ? ` (${invoice.old_uid})`
                                    : ""}
                                </Typography>
                              </TableCell>

                              <TableCell sx={tableCellLab}>
                                <Typography
                                  color={
                                    invoice?.grand_total < 0
                                      ? "neutral.textDanger"
                                      : "text.black"
                                  }
                                  variant="body_Grey1"
                                >
                                  {" "}
                                  INR {invoice.grand_total}
                                </Typography>
                              </TableCell>

                              <TableCell sx={tableCellLab}>
                                <Typography
                                  color={
                                    invoice?.grand_total < 0
                                      ? "neutral.textDanger"
                                      : "text.black"
                                  }
                                  variant="body_Grey1"
                                >
                                  {getPaymentModeLabel(invoice)}
                                </Typography>
                              </TableCell>

                              <TableCell sx={tableCellLab}>
                                <Typography
                                  color={
                                    invoice?.grand_total < 0
                                      ? "neutral.textDanger"
                                      : "text.black"
                                  }
                                  variant="body_Grey1"
                                >
                                  {dayjs(
                                    invoice?.generated_at,
                                    "YYYY-MM-DD hh:mm A",
                                  ).format("MMMM DD YYYY, hh:mm A")}
                                </Typography>
                              </TableCell>

                              <TableCell
                                sx={{
                                  ...tableCellLab,
                                  paddingY: "8px",
                                  paddingX: "20px",
                                  borderTopRightRadius: "20px",
                                  borderBottomRightRadius: "20px",
                                }}
                              >
                                <Button
                                  sx={{
                                    ...primaryBtnTeal,
                                    color: "white",
                                    paddingY: "2px",
                                    paddingX: "20px",
                                    fontSize: "15px",
                                  }}
                                  onClick={() => {
                                    handleOpenBillByInvoice(invoice?.id);
                                    setSelectedInvoiceUid(invoice?.uid);
                                    setSelectedDate(!isOlderThan36Hours);
                                  }}
                                >
                                  {!isOlderThan36Hours ? "Modify" : "View"}
                                </Button>
                                {/* )} */}
                              </TableCell>
                            </TableRow>
                          );
                        },
                      )}
                </TableBody>
              </Table>

              {!isLoading && !collectionArray?.payload?.invoices?.length && (
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexDirection: "column",
                    width: "30%",
                    margin: "auto",
                    marginTop: "60px",
                  }}
                >
                  <Box sx={{ margin: "auto", width: "40%" }}>
                    <img
                      src={not_found}
                      alt=""
                      width={"100%"}
                      sx={{ margin: "auto" }}
                    />
                  </Box>
                  <Typography
                    align="center"
                    fontSize={"17px"}
                    color={"crimson"}
                    textTransform={"capitalize"}
                  >
                    {" "}
                    collections not found for selected date
                  </Typography>
                </Box>
              )}
            </TableContainer>
          </Grid>
        </Grid>
      </Box>

      <Box
        sx={{
          marginTop: 2,
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            gap: "20px",
            alignItems: "center",
            justifyContent: "center",
            alignSelf: "flex-end",
          }}
        >
          <Box gap={1} justifyContent="end" display="flex" alignItems="center" flexWrap="wrap">
            {/* Previous */}
            <Button
              onClick={handlePrevious}
              disabled={page === 1}
              startIcon={<ArrowBackIcon sx={{ fontSize: "14px !important" }} />}
              sx={{ fontSize: "12px", textTransform: "capitalize", color: page === 1 ? "grey" : "#336cfb", minWidth: "auto" }}
            >
              Prev
            </Button>

            {/* Page numbers with ellipsis */}
            {(() => {
              const pages = [];
              if (totalPage <= 7) {
                for (let i = 1; i <= totalPage; i++) pages.push(i);
              } else {
                pages.push(1);
                if (page > 3) pages.push("...");
                for (let i = Math.max(2, page - 1); i <= Math.min(totalPage - 1, page + 1); i++) pages.push(i);
                if (page < totalPage - 2) pages.push("...");
                pages.push(totalPage);
              }
              return pages.map((p, i) =>
                p === "..." ? (
                  <Typography key={`ellipsis-${i}`} sx={{ fontSize: "12px", color: "#888", px: "2px", alignSelf: "center" }}>…</Typography>
                ) : (
                  <Button
                    key={p}
                    onClick={() => setPage(p)}
                    sx={{
                      fontSize: "12px",
                      minWidth: "30px",
                      height: "30px",
                      padding: "2px",
                      borderRadius: "6px",
                      color: page === p ? "#fff" : "#333",
                      backgroundColor: page === p ? "#007A99" : "#fff",
                      border: "1px solid #d0d0d0",
                      "&:hover": { backgroundColor: page === p ? "#007A99" : "#f2f2f2" },
                    }}
                  >
                    {p}
                  </Button>
                )
              );
            })()}

            {/* Next */}
            <Button
              onClick={handleNext}
              disabled={page === totalPage}
              endIcon={<ArrowForwardIcon sx={{ fontSize: "14px !important" }} />}
              sx={{ fontSize: "12px", textTransform: "capitalize", color: page === totalPage ? "grey" : "#336cfb", minWidth: "auto" }}
            >
              Next
            </Button>

            {/* Jump to page */}
            <Box display="flex" alignItems="center" gap="4px" ml={1}>
              <Typography sx={{ fontSize: "12px", color: "#555", whiteSpace: "nowrap" }}>Go to</Typography>
              <TextField
                size="small"
                type="number"
                inputProps={{ min: 1, max: totalPage, style: { padding: "2px 6px", fontSize: "12px", width: "44px", textAlign: "center" } }}
                sx={{ "& .MuiOutlinedInput-root": { borderRadius: "6px", height: "30px" } }}
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    const val = parseInt(e.target.value, 10);
                    if (val >= 1 && val <= totalPage) { setPage(val); e.target.value = ""; }
                  }
                }}
              />
            </Box>
          </Box>

          <FormControl variant="outlined" size="small" sx={{ width: "90px" }}>
            <InputLabel id="items-per-page-label">Rows</InputLabel>
            <Select
              labelId="items-per-page-label"
              label="Rows"
              value={itemPerPage}
              onChange={(e) => setItemPerPage(e.target.value)}
              sx={{ height: "30px", "&:hover": { boxShadow: "0 8px 24px rgba(0,0,0,0.12)" } }}
            >
              <MenuItem value={20}>20</MenuItem>
              <MenuItem value={50}>50</MenuItem>
              <MenuItem value={100}>100</MenuItem>
            </Select>
          </FormControl>
        </Box>
      </Box>

      <CustomModal
        customStyles={{ minWidth: "80%" }}
        open={openBillByInvoice}
        onClose={handleOpenBillByInvoiceClose}
      >
        <PastBillPharmacyByInvoice
          id={selectedInvoiceId}
          uid={selectedInvoiceUid}
          setOpenBillByInvoice={setOpenBillByInvoice}
          onClose={handleOpenBillByInvoiceClose}
          refetch={refetch}
          showBtn={!selectedDate}
        />
      </CustomModal>
    </Box>
  );
};

export default PharmacyTodaysCollection;
